// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ugc-content {
  min-height: 100vh;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ugc-main {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  padding: clamp(80px, 14vh, 140px) clamp(20px, 5vw, 32px) 60px;
  position: relative;
  z-index: 5;
}

.ugc-title {
  margin: 0 0 clamp(12px, 2vh, 20px) 0;
  font-size: clamp(36px, 4.5vw, 52px);
  font-weight: 400;
  line-height: 1.1;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'Times New Roman', serif;
  text-align: center;
}

.ugc-title-em {
  font-style: italic;
}

.ugc-subtitle {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: clamp(13px, 1.4vw, 15px);
  line-height: 1.65;
  color: var(--color-text-secondary);
  max-width: 460px;
  margin: 0 auto clamp(28px, 5vh, 44px);
  text-align: center;
}

/* ── Sections ── */

.ugc-section {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 16px;
}

.ugc-section-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--color-border-input);
}

.ugc-section-number {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 22px;
  font-weight: 400;
  color: var(--color-text-primary);
  opacity: 0.15;
  line-height: 1;
  flex-shrink: 0;
}

.ugc-section-label {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ugc-section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.ugc-section-desc {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.ugc-section-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

/* ── Upload Zone ── */

.ugc-upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.ugc-upload-hint {
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.7;
}

/* ── Buttons ── */

.ugc-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.ugc-btn-primary:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.ugc-btn-primary svg {
  width: 15px;
  height: 15px;
}

.ugc-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background 0.15s ease;
}

.ugc-btn-secondary:hover {
  background: var(--color-bg-root);
}

.ugc-btn-secondary svg {
  width: 14px;
  height: 14px;
}

.ugc-btn-remove {
  padding: 6px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.ugc-btn-remove:hover {
  background: var(--color-bg-root);
  color: var(--color-text-primary);
}

/* ── Preview Box ── */

.ugc-preview-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.ugc-preview-media {
  width: 100%;
  max-height: 280px;
  object-fit: contain;
  border-radius: 4px;
  background: var(--color-bg-input);
}

.ugc-default-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.ugc-default-selected-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

/* ── Default Characters Grid ── */

.ugc-or-divider {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
}

.ugc-or-divider::before,
.ugc-or-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--color-border-input);
}

.ugc-or-divider span {
  font-size: 11px;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
  flex-shrink: 0;
}

.ugc-defaults-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  width: 100%;
}

.ugc-default-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0;
  border-radius: 6px;
  border: 2px solid transparent;
  background: var(--color-bg-canvas-surface);
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.ugc-default-card:hover {
  transform: translateY(-2px);
  border-color: var(--color-border-input);
}

.ugc-default-card--selected {
  border-color: var(--color-text-primary);
}

.ugc-default-thumb {
  width: 100%;
  aspect-ratio: 9 / 16;
  object-fit: cover;
  border-radius: 4px;
}

.ugc-default-name {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 4px 6px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  background: linear-gradient(to top, rgba(0,0,0,0.55), transparent);
  pointer-events: none;
}

/* ── Product Grid ── */

.ugc-product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 8px;
  width: 100%;
}

.ugc-product-thumb-wrap {
  position: relative;
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
}

.ugc-product-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ugc-product-thumb-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.ugc-product-thumb-wrap:hover .ugc-product-thumb-remove {
  opacity: 1;
}

.ugc-product-thumb-remove svg {
  width: 12px;
  height: 12px;
}

.ugc-product-thumb-badge {
  position: absolute;
  bottom: 4px;
  left: 4px;
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* ── Prompt Input ── */

.ugc-prompt-input {
  display: block;
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  line-height: 1.6;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s ease;
  box-sizing: border-box;
}

.ugc-prompt-input::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.ugc-prompt-input:focus {
  border-color: var(--color-text-primary);
}

/* ── Submit ── */

.ugc-submit-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.ugc-btn-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 28px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.ugc-btn-submit:hover:not(:disabled) {
  opacity: 0.88;
  transform: translateY(-1px);
}

.ugc-btn-submit:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  transform: none;
}

.ugc-btn-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2.5px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ugc-spin 0.6s linear infinite;
  vertical-align: middle;
  margin-right: 8px;
  flex-shrink: 0;
}

@keyframes ugc-spin {
  to { transform: rotate(360deg); }
}

.ugc-submit-error {
  display: block;
  color: #ef4444;
  font-size: 12px;
  text-align: center;
}

/* ── Number of Ideas Input ── */

.ugc-num-ideas-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.ugc-num-ideas-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.ugc-num-ideas-input {
  width: 64px;
  padding: 8px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  text-align: center;
  outline: none;
  transition: border-color 0.15s ease;
}

.ugc-num-ideas-input:focus {
  border-color: var(--color-text-primary);
}

.ugc-captions-row {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 4px;
}

.ugc-captions-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ugc-captions-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--color-text-primary);
  cursor: pointer;
}

/* ── Ideas Section ── */

.ugc-ideas-section {
  width: 100%;
}

.ugc-ideas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ugc-ideas-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 22px;
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.ugc-ideas-count {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 12px;
  padding: 2px 8px;
  color: var(--color-text-secondary);
}

.ugc-ideas-hint {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin: 0 0 16px;
}

.ugc-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.ugc-btn-back:hover {
  background: var(--color-bg-root);
  color: var(--color-text-primary);
}

.ugc-btn-back svg {
  width: 14px;
  height: 14px;
}

/* ── Idea Cards ── */

.ugc-ideas-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}

.ugc-idea-card {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  padding: 16px;
  transition: border-color 0.15s ease;
}

.ugc-idea-card--selected {
  border-color: var(--color-text-primary);
}

.ugc-idea-card--generating {
  opacity: 0.85;
}

.ugc-idea-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.ugc-idea-select {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid var(--color-border-input);
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.15s ease, background 0.15s ease;
  padding: 0;
}

.ugc-idea-select:hover {
  border-color: var(--color-text-secondary);
}

.ugc-idea-select--active {
  border-color: var(--color-text-primary);
  background: var(--color-text-primary);
}

.ugc-idea-select--active svg {
  width: 12px;
  height: 12px;
  color: var(--color-bg-canvas-surface);
}

.ugc-idea-title-wrap {
  flex: 1 1;
  min-width: 0;
}

.ugc-idea-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  display: block;
}

.ugc-idea-preview {
  font-size: 12px;
  line-height: 1.6;
  color: var(--color-text-secondary);
  white-space: pre-wrap;
  word-break: break-word;
}

.ugc-idea-expand-btn {
  display: inline-block;
  margin-top: 8px;
  padding: 0;
  border: none;
  background: none;
  color: var(--color-accent-base, #6366f1);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.ugc-idea-expand-btn:hover {
  opacity: 0.7;
}

/* ── Idea Status ── */

.ugc-idea-status {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ugc-idea-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--color-border-input);
  border-top-color: var(--color-text-primary);
  border-radius: 50%;
  animation: ugc-spin 0.6s linear infinite;
}

.ugc-btn-go-to-project {
  padding: 5px 12px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s ease;
}

.ugc-btn-go-to-project:hover {
  opacity: 0.88;
}

.ugc-idea-error {
  font-size: 11px;
  font-weight: 500;
  color: #ef4444;
}

/* ── Custom Script Card ── */

.ugc-custom-script-card {
  border-style: dashed;
}

.ugc-custom-script-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  border: none;
  background: none;
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s ease;
}

.ugc-custom-script-btn:hover {
  color: var(--color-text-primary);
}

.ugc-custom-script-btn svg {
  width: 16px;
  height: 16px;
}

.ugc-custom-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ugc-custom-title-input {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s ease;
  box-sizing: border-box;
}

.ugc-custom-title-input::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.ugc-custom-title-input:focus {
  border-color: var(--color-text-primary);
}

.ugc-custom-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* ── Generating Label ── */

.ugc-generating-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
}

/* ── How it Works ── */

.ugc-how {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  padding: 64px clamp(20px, 5vw, 32px) 0;
  text-align: center;
}

.ugc-how-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0 0 32px;
}

.ugc-how-title em {
  font-style: italic;
  color: var(--color-accent-base);
}

.ugc-steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: var(--color-border-input);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
}

.ugc-step {
  background: var(--color-bg-canvas-surface);
  padding: 28px 20px;
  text-align: center;
  transition: background 0.15s ease;
}

.ugc-step:hover {
  background: var(--color-bg-root);
}

.ugc-step-number {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 28px;
  font-weight: 400;
  color: var(--color-text-primary);
  opacity: 0.12;
  line-height: 1;
  margin-bottom: 14px;
}

.ugc-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  color: var(--color-accent-base);
  margin: 0 auto 12px;
}

.ugc-step-icon svg {
  width: 20px;
  height: 20px;
}

.ugc-step-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 18px;
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0 0 4px;
}

.ugc-step-desc {
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  margin: 0;
}

/* ── Footer ── */

.ugc-footer {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  padding: 40px clamp(20px, 5vw, 32px) 80px;
  text-align: center;
  font-size: 12px;
  color: var(--color-text-secondary);
  opacity: 0.6;
}

/* ── Responsive ── */

@media (max-width: 640px) {
  .ugc-main {
    padding-top: 60px;
  }

  .ugc-section-body {
    padding: 16px;
  }

  .ugc-defaults-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  .ugc-product-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .ugc-steps {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/UgcPage.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8EAA8E;EAC9E,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,6DAA6D;EAC7D,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,mCAAmC;EACnC,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,mBAAmB;;AAEnB;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA,kBAAkB;;AAElB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,kCAAkC;;AAElC;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;AACtB;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,uBAAuB;;AAEvB;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,eAAe;AACjB;;AAEA,wBAAwB;;AAExB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0DAA0D;EAC1D,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;;AAEtB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;;AAE7B;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,aAAa;EACb,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;AACX;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA,qBAAqB;;AAErB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n.ugc-content {\n  min-height: 100vh;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.ugc-main {\n  max-width: 640px;\n  width: 100%;\n  margin: 0 auto;\n  padding: clamp(80px, 14vh, 140px) clamp(20px, 5vw, 32px) 60px;\n  position: relative;\n  z-index: 5;\n}\n\n.ugc-title {\n  margin: 0 0 clamp(12px, 2vh, 20px) 0;\n  font-size: clamp(36px, 4.5vw, 52px);\n  font-weight: 400;\n  line-height: 1.1;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  text-align: center;\n}\n\n.ugc-title-em {\n  font-style: italic;\n}\n\n.ugc-subtitle {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: clamp(13px, 1.4vw, 15px);\n  line-height: 1.65;\n  color: var(--color-text-secondary);\n  max-width: 460px;\n  margin: 0 auto clamp(28px, 5vh, 44px);\n  text-align: center;\n}\n\n/* ── Sections ── */\n\n.ugc-section {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.ugc-section-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.ugc-section-number {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 22px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  opacity: 0.15;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.ugc-section-label {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ugc-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.ugc-section-desc {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.ugc-section-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n/* ── Upload Zone ── */\n\n.ugc-upload-zone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.ugc-upload-hint {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  opacity: 0.7;\n}\n\n/* ── Buttons ── */\n\n.ugc-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.ugc-btn-primary:hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.ugc-btn-primary svg {\n  width: 15px;\n  height: 15px;\n}\n\n.ugc-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.ugc-btn-secondary:hover {\n  background: var(--color-bg-root);\n}\n\n.ugc-btn-secondary svg {\n  width: 14px;\n  height: 14px;\n}\n\n.ugc-btn-remove {\n  padding: 6px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.ugc-btn-remove:hover {\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n}\n\n/* ── Preview Box ── */\n\n.ugc-preview-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.ugc-preview-media {\n  width: 100%;\n  max-height: 280px;\n  object-fit: contain;\n  border-radius: 4px;\n  background: var(--color-bg-input);\n}\n\n.ugc-default-selected {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.ugc-default-selected-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n/* ── Default Characters Grid ── */\n\n.ugc-or-divider {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 4px 0;\n}\n\n.ugc-or-divider::before,\n.ugc-or-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--color-border-input);\n}\n\n.ugc-or-divider span {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.ugc-defaults-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  width: 100%;\n}\n\n.ugc-default-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border-radius: 6px;\n  border: 2px solid transparent;\n  background: var(--color-bg-canvas-surface);\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  transition: border-color 0.15s ease, transform 0.15s ease;\n}\n\n.ugc-default-card:hover {\n  transform: translateY(-2px);\n  border-color: var(--color-border-input);\n}\n\n.ugc-default-card--selected {\n  border-color: var(--color-text-primary);\n}\n\n.ugc-default-thumb {\n  width: 100%;\n  aspect-ratio: 9 / 16;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.ugc-default-name {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 16px 4px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #fff;\n  text-align: center;\n  background: linear-gradient(to top, rgba(0,0,0,0.55), transparent);\n  pointer-events: none;\n}\n\n/* ── Product Grid ── */\n\n.ugc-product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: 8px;\n  width: 100%;\n}\n\n.ugc-product-thumb-wrap {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n}\n\n.ugc-product-thumb {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.ugc-product-thumb-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  border: none;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n}\n\n.ugc-product-thumb-wrap:hover .ugc-product-thumb-remove {\n  opacity: 1;\n}\n\n.ugc-product-thumb-remove svg {\n  width: 12px;\n  height: 12px;\n}\n\n.ugc-product-thumb-badge {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 9px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n/* ── Prompt Input ── */\n\n.ugc-prompt-input {\n  display: block;\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  line-height: 1.6;\n  resize: vertical;\n  outline: none;\n  transition: border-color 0.15s ease;\n  box-sizing: border-box;\n}\n\n.ugc-prompt-input::placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n.ugc-prompt-input:focus {\n  border-color: var(--color-text-primary);\n}\n\n/* ── Submit ── */\n\n.ugc-submit-area {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.ugc-btn-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 14px 28px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.ugc-btn-submit:hover:not(:disabled) {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.ugc-btn-submit:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.ugc-btn-spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2.5px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: ugc-spin 0.6s linear infinite;\n  vertical-align: middle;\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n\n@keyframes ugc-spin {\n  to { transform: rotate(360deg); }\n}\n\n.ugc-submit-error {\n  display: block;\n  color: #ef4444;\n  font-size: 12px;\n  text-align: center;\n}\n\n/* ── Number of Ideas Input ── */\n\n.ugc-num-ideas-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 12px;\n}\n\n.ugc-num-ideas-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.ugc-num-ideas-input {\n  width: 64px;\n  padding: 8px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  text-align: center;\n  outline: none;\n  transition: border-color 0.15s ease;\n}\n\n.ugc-num-ideas-input:focus {\n  border-color: var(--color-text-primary);\n}\n\n.ugc-captions-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-top: 4px;\n}\n\n.ugc-captions-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.ugc-captions-label input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--color-text-primary);\n  cursor: pointer;\n}\n\n/* ── Ideas Section ── */\n\n.ugc-ideas-section {\n  width: 100%;\n}\n\n.ugc-ideas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.ugc-ideas-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 22px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ugc-ideas-count {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 12px;\n  padding: 2px 8px;\n  color: var(--color-text-secondary);\n}\n\n.ugc-ideas-hint {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin: 0 0 16px;\n}\n\n.ugc-btn-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.ugc-btn-back:hover {\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n}\n\n.ugc-btn-back svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* ── Idea Cards ── */\n\n.ugc-ideas-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.ugc-idea-card {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  padding: 16px;\n  transition: border-color 0.15s ease;\n}\n\n.ugc-idea-card--selected {\n  border-color: var(--color-text-primary);\n}\n\n.ugc-idea-card--generating {\n  opacity: 0.85;\n}\n\n.ugc-idea-card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.ugc-idea-select {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 2px solid var(--color-border-input);\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: border-color 0.15s ease, background 0.15s ease;\n  padding: 0;\n}\n\n.ugc-idea-select:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.ugc-idea-select--active {\n  border-color: var(--color-text-primary);\n  background: var(--color-text-primary);\n}\n\n.ugc-idea-select--active svg {\n  width: 12px;\n  height: 12px;\n  color: var(--color-bg-canvas-surface);\n}\n\n.ugc-idea-title-wrap {\n  flex: 1;\n  min-width: 0;\n}\n\n.ugc-idea-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  display: block;\n}\n\n.ugc-idea-preview {\n  font-size: 12px;\n  line-height: 1.6;\n  color: var(--color-text-secondary);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.ugc-idea-expand-btn {\n  display: inline-block;\n  margin-top: 8px;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--color-accent-base, #6366f1);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.ugc-idea-expand-btn:hover {\n  opacity: 0.7;\n}\n\n/* ── Idea Status ── */\n\n.ugc-idea-status {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ugc-idea-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--color-border-input);\n  border-top-color: var(--color-text-primary);\n  border-radius: 50%;\n  animation: ugc-spin 0.6s linear infinite;\n}\n\n.ugc-btn-go-to-project {\n  padding: 5px 12px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: opacity 0.15s ease;\n}\n\n.ugc-btn-go-to-project:hover {\n  opacity: 0.88;\n}\n\n.ugc-idea-error {\n  font-size: 11px;\n  font-weight: 500;\n  color: #ef4444;\n}\n\n/* ── Custom Script Card ── */\n\n.ugc-custom-script-card {\n  border-style: dashed;\n}\n\n.ugc-custom-script-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px;\n  border: none;\n  background: none;\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.ugc-custom-script-btn:hover {\n  color: var(--color-text-primary);\n}\n\n.ugc-custom-script-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.ugc-custom-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ugc-custom-title-input {\n  display: block;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.15s ease;\n  box-sizing: border-box;\n}\n\n.ugc-custom-title-input::placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n.ugc-custom-title-input:focus {\n  border-color: var(--color-text-primary);\n}\n\n.ugc-custom-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* ── Generating Label ── */\n\n.ugc-generating-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* ── How it Works ── */\n\n.ugc-how {\n  max-width: 640px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 64px clamp(20px, 5vw, 32px) 0;\n  text-align: center;\n}\n\n.ugc-how-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(24px, 3vw, 32px);\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0 0 32px;\n}\n\n.ugc-how-title em {\n  font-style: italic;\n  color: var(--color-accent-base);\n}\n\n.ugc-steps {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1px;\n  background: var(--color-border-input);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.ugc-step {\n  background: var(--color-bg-canvas-surface);\n  padding: 28px 20px;\n  text-align: center;\n  transition: background 0.15s ease;\n}\n\n.ugc-step:hover {\n  background: var(--color-bg-root);\n}\n\n.ugc-step-number {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 28px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  opacity: 0.12;\n  line-height: 1;\n  margin-bottom: 14px;\n}\n\n.ugc-step-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-accent-base);\n  margin: 0 auto 12px;\n}\n\n.ugc-step-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.ugc-step-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 18px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0 0 4px;\n}\n\n.ugc-step-desc {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* ── Footer ── */\n\n.ugc-footer {\n  max-width: 640px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 40px clamp(20px, 5vw, 32px) 80px;\n  text-align: center;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n/* ── Responsive ── */\n\n@media (max-width: 640px) {\n  .ugc-main {\n    padding-top: 60px;\n  }\n\n  .ugc-section-body {\n    padding: 16px;\n  }\n\n  .ugc-defaults-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .ugc-product-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .ugc-steps {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
